import * as React from 'react';
import { ItemFieldProps } from './types';
import { BooleanField } from './booleanField';
import { TaskGroup } from '../../../../enums/TaskGroup';

export const InThePlanField = (f: ItemFieldProps) => {
  const group = f.group;
  if (
    group?.props?.isMyTaskGroup &&
    group.props.name != TaskGroup.ConceptReview
  ) {
    return null;
  }
  return <BooleanField {...f} />;
};
